import styled from 'styled-components';
import { BaseButton } from 'library/components/button';
import { Users, Pencil } from 'library/icons';

const CreateNewGroupRow = styled.div`
  display: flex;
  align-items: center;
`;

const Button = styled(BaseButton)`
  &&& {
    display: ${(props) => (props.active == false ? 'none' : 'flex')};
    justify-content: center;
    align-items: center;
  }
  margin: 0 1em;
  color: #08394b;
  background: #efc13b;
  font-size: 1em;
  padding: 1em;
  height: 36px;
  width: 86px;
  border: 0;
  text-transform: capitalize;

  @media (max-width: 768px) {
    font-size: 0.85em;
  }
`;

const UsersIcon = styled(Users)`
  color: #6fc1b3;
`;
const PencilIcon = styled(Pencil)`
  color: #6fc1b3;
  margin-left: 1em;
  cursor: pointer;
  display: ${(props) => (props.active ? 'initial' : 'none')};
  position: ${(props) => (props.absolute ? 'absolute' : 'initial')};
`;

export { CreateNewGroupRow, Button, UsersIcon, PencilIcon };
